import Layout from 'components/layout';
import Head from 'next/head';
import React, { useRef, useState } from 'react';
import { Button, Form, Input, Row, Col } from 'antd';
import style from 'styles/contact/index.module.scss';
import { action } from 'action/index';
import TryModal from 'components/tryModal/index';
const FormItem = Form.Item;
const pageTitle = '联系销售';

const Contact = () => {
  const [submitStatus, setSubmitStatus] = useState(false);
  const [form] = Form.useForm();
  const modalRef = useRef<any>(null);

  const onFinish = async (values: any) => {
    setSubmitStatus(true);
    if (!values) return;
    values.applicationType = '0';

    const result = await action.submit(values, 'contact');

    if (!result) {
      modalRef.current?.open?.(false, true);
    } else {
      modalRef.current?.open?.(true, true);
    }
    form.resetFields();
    setSubmitStatus(false);
  };
  return (
    <Layout>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <div className={style.banner}>{pageTitle}</div>
      <div className={style.form}>
        <Form form={form} className={style.formInfo} onFinish={onFinish}>
          <div className={style.title}>{pageTitle}</div>
          <Row gutter={30}>
            <Col md={12} xs={24}>
              <FormItem
                name={'contactName'}
                rules={[
                  {
                    required: true,
                    message: '请填写您的姓名',
                  },
                ]}
              >
                <Input placeholder="您的姓名" />
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                name={'contactPhone'}
                rules={[
                  {
                    required: true,
                    message: '请填写您的联系电话',
                  },
                  {
                    pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                    message: '填写的电话号码格式不正确',
                  },
                ]}
              >
                <Input placeholder="联系电话" />
              </FormItem>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col md={12} xs={24}>
              <FormItem
                name={'contactEmail'}
                rules={[
                  {
                    required: true,
                    message: '请填写您的邮箱',
                  },
                  {
                    type: 'email',
                    message: '您填写的邮箱格式不正确',
                  },
                ]}
              >
                <Input placeholder="您的邮箱" />
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                name={'contactEnterpriseName'}
                rules={[
                  {
                    required: true,
                    message: '请填写您的公司名称',
                  },
                ]}
              >
                <Input placeholder="公司名称" />
              </FormItem>
            </Col>
          </Row>
          <FormItem
            name={'customerDemand'}
            className={style.textArea}
            rules={[
              {
                required: true,
                message: '请填写您的需求',
              },
            ]}
          >
            <Input.TextArea placeholder="您的需求" />
          </FormItem>
          <FormItem className={style.submit}>
            <Button type="primary" htmlType="submit" loading={submitStatus}>
              {submitStatus ? '提交中...' : '提交'}
            </Button>
          </FormItem>
        </Form>
      </div>
      <footer className={style.footer}>
        <div className={style.title}>您也可以通过以下方式联系销售</div>
        <div className={style.phone}>400-900-3567</div>
        <div className={style.email}>sales@xylink.com</div>
      </footer>
      <TryModal ref={modalRef} />
    </Layout>
  );
};

export default Contact;
